module.exports = __webpack_public_path__ + "media/club_product_v2/error-icon-e23cc81d.svg";